import { CASINO_RACE_QUERY } from './GraphQlQuery/CasinoRaceGraphqlQueries';
import type { CasinoRaceDataResult } from './Type/CasinoRaceTypes';
import { pokerGraphqlRequest } from '../Utils/PokerGraphqlClient';

export const getCasinoRace = async (args: {
  slug?: string;
  limit?: number;
  signal?: AbortSignal;
} = {}): Promise<CasinoRaceDataResult> => {
  const variables: { slug?: string; limit?: number } = {
    slug: args.slug || 'all-race',
  };

  if (typeof args.limit === 'number' && Number.isFinite(args.limit)) {
    variables.limit = args.limit;
  }

  const res = await pokerGraphqlRequest<
    { casinoRace: CasinoRaceDataResult },
    { slug?: string; limit?: number }
  >({
    query: CASINO_RACE_QUERY,
    variables,
    signal: args.signal,
  });

  return res.casinoRace;
};
